import { FontStyle }   from './font.style';
import { FontVariant } from './font.variant';
import { FontWeight }  from './font.weight';
import { TextMeasure } from './text.measure';

/**
 *
 * @class TestOptions
 *
 * font formatting options
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      January 2024
 *
 */
export class TextOptions {

  /** what font families we allow */
  public static supportedFamilies: string[] = [
    'Arial',
    'Verdana',
    'Times New Roman',
    'Courier New',
    'serif',
    'sans-serif'
  ];

  /** the height of the raw text */
  public size: number         = 10;

  /** which family to use */
  public family: string       = 'Arial';

  /** italic? */
  public style: FontStyle     = FontStyle.NORMAL;

  /** small caps? */
  public variant: FontVariant = FontVariant.NORMAL;

  /** how heavy */
  public weight: FontWeight   = FontWeight.NORMAL;

  /** the actual text */
  public text: string         = 'O';

  /** the bounding width (if known) */
  public width: number        = 0;

  /** the bounding height (if known) */
  public height: number       = 0;

  /** standard constructor */
  constructor(init?: Partial<TextOptions>) {

    if (init) {

      /* double-check the overrides */

      if (!TextOptions.supportedFamilies.find((x) => x == init?.family ?? 'Arial')) {

        init.family = 'Arial';
      }

      if ((init?.size ?? 0) < 0) {

        init.size = -(init?.size ?? 0);
      }

      init.width  = 0;
      init.height = 0;

    }

    /* do any provided overrides */

    Object.assign(this, init);

    /* get the bounding area ... */

    let result: {width: number, height: number} = TextMeasure.measure(this.text, this.format());

    this.width  = result.width;
    this.height = result.height;
  }

  /** fetch a string suitable for use as a 'font' property */
  public format(): string {

    return `${this.variant} ${this.style} ${this.weight} ${this.size}px ${this.family}`;
  }

  /** convenience to fetch the width of this text */
  public measureWidth(): number {

    return TextMeasure.measure(this.text, this.format()).width;
  }

}
